import { render } from "./CategoriaDetalle.vue?vue&type=template&id=0c8ab595&scoped=true"
import script from "./CategoriaDetalle.vue?vue&type=script&lang=js"
export * from "./CategoriaDetalle.vue?vue&type=script&lang=js"

import "./CategoriaDetalle.vue?vue&type=style&index=0&id=0c8ab595&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8ab595"]])

export default __exports__